import { classifyRepo, isEmptyRepo } from '../projects/import/repoState';
import type { Repository } from '../../types';

/**
 * Returns true if the repo should appear as a row in the bulk-import modal.
 * Hides currently-connected repos and empty repositories; surfaces unimported,
 * connectable, and disconnected repos so the user can bulk import / [re]connect them.
 */
export function isRepoVisibleForBulkImport(repo: Repository): boolean {
  if (isEmptyRepo(repo)) {
    return false;
  }

  const state = classifyRepo(repo);
  return state !== 'connected';
}
